import i18n from "components/i18n/i18n";
import isDate from "lodash/isDate";
import moment from "moment";

export abstract class OutputHTMLElement extends HTMLElement {

    private _initialValue: OrginalValue = new OrginalValue();
    private _input: HTMLInputElement;

    private _separatorRange: string

    constructor() {
        super();
        this._separatorRange = i18n.instance.t("daterangepicker.locale.separator");
    }

    public set input(input: any) {
        this._input = input;
    }

    public get input() {
        return this._input;
    }

    public get initialValue() {
        return this._initialValue;
    }

    public get separatorRange() {
        return this._separatorRange;
    }

    public isEqualToInitialValue(value: any): boolean {
        let isEqual: boolean = true;
        const initialValue = this.initialValue.value;

        isEqual = (initialValue === value);

        return isEqual;
    }

    public isEqualForDate(actualValue: string | Date, initialValue: string | Date, granurality: moment.unitOfTime.StartOf) {
        let isEqual: boolean = true;

        if (isDate(actualValue) || isDate(initialValue)) {
            isEqual = moment(actualValue).isSame(moment(initialValue), granurality)
        } else {
            isEqual = (initialValue === actualValue);
        }

        return isEqual;
    }

    public isNumeric(str: any) {
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }

    public focus() {
        this._input.focus();
    }

    abstract get data(): unknown;
    abstract set data(v: unknown);

}

export class OrginalValue {

    private _initialized: boolean = false;
    private _value: any;

    public set value(value: any) {
        if (!this._initialized) {
            this._value = value;
            this._initialized = true;
        }
    }

    reassignvalue(value: any) {
        this._value = value;
    }

    public get value() {
        return this._value;
    }
}

export interface DateRangeData {
    from: Date;
    to: Date;
}
export interface DateRangeString {
    from: string;
    to: string;
}

export interface DateTimeRangeData {
    from: Date;
    to: Date;
}
export interface DateTimeRangeString {
    from: string;
    to: string;
}

